<div class="entry-content">
  <div class="box-content">
    <p>
      <strong>
        Política de Privacidad de Rappi y Tratamiento de Datos Personales
      </strong>
    </p>

    <p>
      De conformidad con lo establecido en la Ley N° 29733, Ley de Protección de
      Datos Personales y el Decreto Supremo N° 003-2013-JUS, Reglamento de la
      Ley de Protección de Datos Personales, RAPPI S.A.C., con Registro Único de
      Contribuyentes ("RUC") N° 20602985971, con domicilio en Av. José Pardo N°
      434, Piso 16, Miraflores, Lima, Perú (en adelante, "RAPPI"), le informa
      mediante esta Política de Privacidad (en adelante, la "Política"), las
      condiciones del tratamiento de su información.
    </p>

    <p>
      Como parte normal de nuestras actividades, recopilamos información sobre
      nuestros Usuarios consumidores, Rappitenderos (repartidores) y visitantes
      al sitio web (en adelante, el "Titular"), que acceden y utilizan nuestras
      aplicaciones Rappi y Soy Rappi (en adelante, de manera conjunta, las
      <strong>"Aplicaciones"</strong>) y sitio web
      <a href="http://www.rappi.com.pe/">www.rappi.com.pe</a> (en adelante, el
      "Sitio Web").
    </p>

    <p>
      El Titular consiente de manera libre, expresa, previa e informada que
      RAPPI trate los datos personales que usted nos proporcione mediante los
      formularios electrónicos que se le proponga y los almacene en un banco de
      datos de su titularidad para los fines establecidos en esta Política.
    </p>

    <p>
      Se informa que la información del Titular se almacenará en uno de los
      siguientes bancos de datos personales, por el plazo señalado, según
      corresponda:
    </p>

    <p>
      1) Si usted se registra como Usuario Consumidor en nuestras Aplicaciones y
      Sitio Web
    </p>

    <p>
      Nombre de banco de datos personales: Banco de datos de usuarios
      consumidores
    </p>

    <p>
      Plazo de almacenamiento: Durante el plazo que dure la relación contractual
      entre RAPPI y usted más 10 años.
    </p>

    <p>
      2) Si usted se registra como Usuario Rappitendero en nuestras Aplicaciones
      y Sitio Web
    </p>

    <p>
      Nombre de banco de datos personales: Banco de datos de repartidores
      independientes
    </p>

    <p>
      Plazo de almacenamiento: Durante el plazo que dure la relación contractual
      entre RAPPI y usted más 10 años.
    </p>

    <p>
      3) Si usted envía un reclamo vía el Libro de Reclamaciones Virtual en
      nuestro Sitio Web
    </p>

    <p>
      Nombre de banco de datos personales: Banco de datos de Libro de
      Reclamaciones
    </p>

    <p>
      Plazo de almacenamiento: Durante el plazo que dure la relación contractual
      entre RAPPI y usted más 2 años.
    </p>

    <p>
      <strong>
        PRIMERA: Derechos de acceso, cancelación y rectificación de la
        Información Personal
      </strong>
    </p>

    <p>
      1.1. El Titular puede ejercer los derechos de acceso, rectificación,
      cancelación u oposición, establecidos en la normativa de protección de
      datos personales.
    </p>

    <p>
      A fin de ejercer los derechos antes mencionados, el Titular deberá seguir
      las instrucciones señaladas en:
      <a href="https://legal.rappi.com/peru/como-puedo-ejercer-mis-derechos-arco/">
        https://legal.rappi.com/peru/como-puedo-ejercer-mis-derechos-arco/ </a>.
    </p>

    <p>
      De considerar el Titular que no ha sido atendido en el ejercicio de sus
      derechos, puede presentar un reclamo ante la Dirección de Protección de
      Datos Personales del Ministerio de Justicia y Derechos Humanos.
    </p>

    <p>
      1.2 En caso que el Titular se registre como Usuario consumidor o Usuario
      Rappitendero, podrá revisar y cambiar la información que ha enviado a
      RAPPI, por motivos debidamente justificados y legítimos, incluyendo:
    </p>

    <ul>
      <li>
        el usuario y dirección de correo electrónico.
      </li>
      <li>
        la información de registro como: domicilio, ciudad, región, código
        postal, número principal de teléfono, número secundario de teléfono,
        correo electrónico, etc.
      </li>
      <li>
        la clave.
      </li>
    </ul>

    <p>
      1.3. RAPPI podrá modificar esta Política. En dicho caso, RAPPI notificará
      al Titular publicando una versión actualizada de la Política en esta
      página y mediante el envío de un e-mail o informándolo en el Sitio Web o
      Aplicaciones, a efectos de mantener actualizado al Titular. El Titular
      acepta que, si después de dicha notificación, mantiene su registro en el
      Sitio Web y Aplicaciones, es porque está de acuerdo con las mismas. Si no
      está de acuerdo, el Titular deberá solicitar darse de baja a RAPPI, en
      cuyo caso, RAPPI no tratará más su información, sino únicamente para el
      cumplimiento de la ley aplicable.
    </p>

    <p>
      <strong>
        SEGUNDA: La Información Personal que recopilamos
      </strong>
    </p>

    <p>
      2.1. A fin de acceder como Usuario Consumidor a la aplicación Rappi, los
      Titulares deben registrarse, suministrando ciertos datos personales
      completos y exactos. RAPPI podrá solicitar, recabar y almacenar la
      siguiente información personal: apodo o seudónimo (nombre de Titular de
      los datos) para operar en el sitio de RAPPI, nombre y apellido, número de
      documento o identificación válida, información física de contacto (como
      número de teléfono, domicilio, tipo de domicilio, dirección de e-mail,
      etc.), historial de compras, preferencias de consumo, información
      bancaria.
    </p>

    <p>
      2.2. Al fin de acceder como Usuario Rappitendero a la aplicación Soy
      Rappi, los Titulares deben registrarse, suministrando ciertos datos
      personales completos y exactos. RAPPI podrá solicitar, recabar y almacenar
      la siguiente información personal: apodo o seudónimo (nombre de Titular de
      los datos) para operar en el sitio de RAPPI, nombre y apellido, género,
      número de documento o identificación válida, fecha de nacimiento, medio de
      transporte, información física de contacto (como número de teléfono
      domicilio, dirección de e-mail, etc.), transacciones, fecha de registro,
      Id, información bancaria.
    </p>

    <p>
      2.3. A fin de Interponer un Reclamo en el Libro de Reclamaciones en el
      Sitio Web, RAPPI recopilará datos de usted tales como nombres y apellidos,
      documento de identidad, domicilio, teléfono, edad, reclamo, correo
      electrónico e información de compra.
    </p>

    <p>En adelante, la "Información Personal".</p>

    <p>
      RAPPI podrá confirmar la Información Personal suministrada acudiendo a
      fuentes de acceso público, tales como entidades públicas, compañías
      especializadas o centrales de riesgo. Esta verificación es necesaria para
      mejorar los servicios a través de nuestras Aplicaciones y Sitio Web.
    </p>

    <p>
      <strong>
        TERCERA: Finalidad y Uso de la Información Personal
      </strong>
    </p>

    <p>
      3.1. Su información será tratada de acuerdo a las siguientes finalidades y
      usos, según corresponda:
    </p>

    <ul>
      <li>
        Si usted es un Usuario Rappitendero
      </li>
    </ul>

    <p>
      La Información Personal será tratada para ejecutar la relación contractual
      entre RAPPI y el Rappitendero y para brindar los servicios a los Usuarios
      Consumidores a través de las Aplicaciones y el Sitio Web, de acuerdo a sus
      términos y condiciones.
    </p>

    <p>
      RAPPI podrá compartir los datos de los Rappitenderos a los Usuarios y los
      Rappi Aliados (personas naturales o personas jurídicas que exhiben sus
      productos y/o servicios a través de las Aplicaciones), para que estos se
      comuniquen ante cualquier eventualidad que surja durante la prestación de
      los servicios de reparto.
    </p>

    <p>
      Si usted es Rappitendero, para que pueda aceptar y tramitar las órdenes
      más cercanas a su ubicación, la Aplicación "Soy Rappi" recogerá datos de
      su localización, aún cuando la Aplicación se encuentre cerrada o no esté
      en uso.
    </p>

    <p>
      El app ‘Soy Rappi’ recoge y almacena el número telefónico del usuario el
      cual es almacenado en nuestra base de datos usando métodos de encriptación
      para garantizar la protección de la información personal del usuario. La
      data recolectada se utiliza para identificar posibles comportamientos
      atípicos dentro de la aplicación y no es compartida ni transferida a
      terceros.
    </p>

    <ul>
      <li>
        Si usted es un usuario Consumidor
      </li>
    </ul>

    <p>
      La Información Personal será tratada para ejecutar la relación contractual
      entre RAPPI y el Usuario Consumidor a través de las Aplicaciones y el
      Sitio Web, de acuerdo a sus términos y condiciones.
    </p>

    <p>
      La Información Personal, sólo podrá ser utilizada por los Rappitenderos en
      el marco de la prestación del servicio de reparto y no deberá ser empleada
      para actividades no relacionadas con y autorizadas por RAPPI. Su
      información podrá ser conocida por los Rappitenderos y los Rappi Aliados.
    </p>

    <p>
      Su información también podrá ser utilizada, de manera anonimizada, para
      realizar estudios internos sobre los intereses, comportamientos y
      demografía del Titular para comprender mejor sus necesidades e intereses y
      ofrecer mejores servicios o proveerles información relacionada.
    </p>

    <ul>
      <li>
        Si usted utiliza nuestros Libros de Reclamaciones de Virtual
      </li>
    </ul>

    <p>
      Su información será tratada únicamente para atender y hacer seguimiento
      del referido reclamo.
    </p>

    <ul>
      <li>
        Consentimiento para fines promocionales
      </li>
    </ul>

    <p>
      <strong>
        Solo y exclusivamente en el caso que usted haya aceptado expresa y
        voluntariamente, mediante las Aplicaciones o el Sitio Web, recibir
        información sobre novedades, descuentos y recomendaciones sobre los
        productos y servicios de RAPPI
      </strong>
      , usted autoriza que RAPPI pueda enviar información a través de diferentes
      medios, tales como mensajes al Titular por e-mail, sms (mensaje de texto)
      y/o a cualquier otro tipo de dispositivos móviles o a través de
      plataformas de mensajería instantánea (incluyendo Whatsapp), sobre
      publicidad o promociones, banners, de interés para el Titular, noticias
      sobre RAPPI.
    </p>

    <p>
      Sin perjuicio de ello, el Titular puede en cualquier momento solicitar que
      lo excluyan de las listas para el envío de información promocional o
      publicitaria, mediante la sección de Soporte disponible a través de la
      plataforma o ejerciendo sus derechos ARCO.
    </p>

    <p>
      Asimismo, si el Titular decide no aceptar recibir estas comunicaciones, al
      momento de registrarse, desmarcando la casilla correspondiente, puede
      otorgar su autorización en cualquier momento posteriormente, a través de
      los centros de soporte correspondientes.
    </p>

    <ul>
      <li>
        Consentimiento para transferencia nacional de datos personales
      </li>
    </ul>

    <p>
      <strong>
        Solo y exclusivamente en el caso que usted haya aceptado expresa y
        voluntariamente, mediante las Aplicaciones o el Sitio Web, que Rappi
        efectúe la transferencia de sus datos personales para el envío de
        novedades o productos financieros
      </strong>
      ¸ usted autoriza que RAPPI pueda transferir su número de Documento
      Nacional de Identidad ("DNI") al Banco Internacional del Perú – Interbank,
      identificado como RUC No. 20100053455, con la finalidad de que este último
      pueda efectuar una validación en sus sistemas para el ofrecimiento de
      productos financieros al Titular que califique, a través de Rappi, en el
      marco de la existencia de una relación comercial entre estas dos
      entidades, y como parte del servicio de RAPPIBANK.
    </p>

    <p>
      En este sentido, usted autoriza que RAPPI pueda enviar información sobre
      estas novedades y productos a través de diferentes medios, tales como
      mensajes al Titular por e-mail, sms (mensaje de texto) y/o a cualquier
      otro tipo de dispositivos móviles o a través de plataformas de mensajería
      instantánea (incluyendo Whatsapp).
    </p>

    <p>
      Sin perjuicio de ello, el Titular puede en cualquier momento solicitar que
      lo excluyan de las listas para el envío de información promocional o
      publicitaria, mediante la sección de Soporte disponible a través de la
      plataforma o ejerciendo sus derechos ARCO.
    </p>

    <p>
      Asimismo, si el Titular decide no aceptar recibir estas comunicaciones, al
      momento de registrarse o actualizar sus datos, desmarcando la casilla
      correspondiente, puede otorgar su autorización en cualquier momento
      posteriormente, a través de los centros de soporte correspondientes.
    </p>

    <p>3.2. Encargo de tratamiento de datos personales:</p>

    <p>
      RAPPI podrá encargar el tratamiento de sus datos personales para los
      siguientes fines:
    </p>

    <p>Si usted es un usuario Rappitendero:</p>

    <p>Entidad: Amazon Web Services, Inc.</p>

    <p>Finalidad: Hosting</p>

    <p>
      Domicilio: Amazon Web Services, Inc., 410 Terry Avenue North, Seattle, WA
      98109-5210, USA
    </p>

    <p>Entidad: Rappi S.A.S.</p>

    <p>Finalidad: Servicios de tecnología</p>

    <p>Domicilio: Calle 71A # 14-27, Bogotá, Colombia.</p>

    <p>Si usted es un usuario consumidor:</p>

    <p>Entidad: Amazon Web Services, Inc.</p>

    <p>Finalidad: Hosting</p>

    <p>
      Domicilio: Amazon Web Services, Inc., 410 Terry Avenue North, Seattle, WA
      98109-5210, USA
    </p>

    <p>Entidad: Rappi S.A.S.</p>

    <p>Finalidad: Servicios de tecnología</p>

    <p>Domicilio: Calle 71A # 14-27, Bogotá, Colombia.</p>

    <p>Si usted utiliza nuestros Libros de Reclamaciones de Virtual:</p>

    <p>Entidad: Amazon Web Services, Inc.</p>

    <p>Finalidad: Hosting</p>

    <p>
      Domicilio: Amazon Web Services, Inc., 410 Terry Avenue North, Seattle, WA
      98109-5210, USA
    </p>

    <p>Entidad: Rappi S.A.S.</p>

    <p>Finalidad: Servicios de tecnología</p>

    <p>Domicilio: Calle 71A # 14-27, Bogotá, Colombia.</p>

    <p>Entidad: OPTIMAX S.R.L.</p>

    <p>Finalidad: Soporte del Libro de Reclamaciones Virtual</p>

    <p>Domicilio: Av. Las Flores de Primavera No. 1020 URB, SJL, Lima, Perú.</p>

    <p>Entidad: Global Tech Communications.</p>

    <p>Finalidad: Hosting del Libro de Reclamaciones Virtual</p>

    <p>Domicilio: Po Box 1402 New Brunswick, Saint-Quentin, Canadá</p>

    <p>
      Otras categorías que posibles encargados de tratamiento de datos
      personales podrían ser: Empresas de Estudios de mercado.
    </p>

    <p>
      En los casos que exista flujo transfronterizo de su Información Personal,
      RAPPI garantiza que será tratada con niveles adecuados de protección.
    </p>

    <p>
      <strong>
        CUARTA: Confidencialidad de la Información Personal
      </strong>
    </p>

    <p>
      4.1. RAPPI no venderá, intercambiará, alquilará o compartirá la
      Información Personal del Titular excepto en las formas establecidas en
      esta Política.
    </p>

    <p>
      <strong>
        QUINTA: Clave Personal
      </strong>
    </p>

    <p>
      5.1. Para acceder a los servicios reservados, el Titular dispondrá de una
      clave personal. Con ella podrá contratar y calificar los servicios que
      prestan por terceros a través de las Aplicaciones o Sitio Web. El Titular
      deberá mantener esta clave bajo absoluta confidencialidad y, en ningún
      caso, deberá revelarla o compartirla con otras personas.
    </p>

    <p>
      5.2. El Titular será responsable de todos los actos que tengan lugar
      mediante el uso de su nombre de Titular y clave, lo que incluye asumir la
      responsabilidad por los daños que puedan sufrir otros Titulares mediante
      su cuenta. Si, por cualquier razón, un Titular creyera que alguien puede
      conocer su clave, deberá modificarla ingresando a la opción de
      modificación dispuesta para tal fin en la plataforma de RAPPI.
    </p>

    <p>
      <strong>
        SEXTA: Menores de Edad
      </strong>
    </p>

    <p>
      6.1. Debes tener más de 14 años para registrarte en la APP o el Sitio como
      usuario consumidor. Para registrarte como usuario Rappitendero, deberás
      tener más de 18 años. Está, por tanto, restringido el registro en la App o
      el Sitio que no cumpla con los límites mínimos de edad.
    </p>

    <p>
      6.2 RAPPI se reserva el derecho de verificar, por los medios legales que
      considere más oportunos y relevantes, la edad real de cualquier Titular de
      los datos.
    </p>

    <p>
      6.3. Ante una sospecha razonable de que un Titular de los datos de la
      Aplicación se ha registrado incumpliendo los límites mínimos de edad o que
      ha falseado los datos que se requieren para su acceso, RAPPI podrá denegar
      el acceso a sus servicios.
    </p>

    <p>
      6.4. En ningún caso, RAPPI solicitará el consentimiento de menores para el
      tratamiento de datos personales para el acceso a actividades, vinculadas
      con bienes o servicios que están restringidos para mayores de edad.
    </p>

    <p>
      <strong>
        SÉPTIMA: Requerimientos Legales
      </strong>
    </p>

    <p>
      7.1. RAPPI cooperará con las autoridades competentes y con otros terceros
      para garantizar el cumplimiento de las leyes.
      <strong>
        RAPPI podrá revelar la Información Personal del Titular sin su
        consentimiento únicamente cuando esté permitido por ley, requerido por
        mandato judicial, o en casos de prevención de lavado de activos o
        financiamiento del terrorismo o el caso que dicho Titular participa de
        actividades ilegales.
      </strong>
      En tales situaciones, RAPPI colaborará con las autoridades competentes con
      el fin de salvaguardar la integridad y la seguridad de la comunidad y la
      de sus Titulares de los datos.
    </p>

    <p>
      <strong>
        OCTAVA: Seguridad y Almacenamiento de la Información Personal
      </strong>
      </p>
      <p>
        8.1. En el tratamiento de la Información Personal, RAPPI garantiza que ha
        adoptado medidas técnicas para garantizar la seguridad de sus datos
        personales. Sin perjuicio de lo expuesto, considerando que internet es un
        sistema abierto, de acceso público, RAPPI no puede garantizar que terceros
        no autorizados no puedan eventualmente superar las medidas de seguridad y
        utilizar la Información Personal en forma indebida, por tratarse de
        eventos imprevisibles.
    </p>

    <p>
      8.2. El Titular conoce y acepta expresamente que RAPPI, a su exclusivo
      criterio, recabe, almacene y eventualmente monitoree el intercambio de
      mensajes y correos electrónicos entre el Usuario Consumidor y Usuario
      Rappitendero, efectuado dentro de las Aplicaciones de RAPPI, con el único
      objetivo de contribuir a la seguridad de las relaciones y comunicaciones
      que se desarrollan a través de éstas.
    </p>
  </div>
</div>
